import React from 'react';
import { Truck } from 'lucide-react';

import { Separator } from '@/components/ui/separator';
import { t } from '../../constants/i18n';
import { formatCurrency } from '../../constants/i18n';
// 免邮进度展示组件：仅负责展示，计算统一由 utils 提供

interface FreeShippingProgressBarProps {
    progressPercent: number; // 0-100
    remainingCents: number;
    currency: string;
}

export const FreeShippingProgressBar: React.FC<FreeShippingProgressBarProps> = ({
    progressPercent,
    remainingCents,
    currency
}) => {
    const progress = Math.min(Math.max(progressPercent, 0), 100);
    const remaining = Math.max(remainingCents, 0);

    const amountPlaceholder = '__AMOUNT__';
    const remainingText = t('freeShippingRemaining', amountPlaceholder);
    const [prefix, suffix] = remainingText.split(amountPlaceholder);

    return (
        <>
            <div className="px-6 py-4 bg-gray-50/80 shrink-0 z-40 border-b border-gray-100/50 backdrop-blur-sm">
                <div className="mb-2 text-sm font-medium text-gray-700 flex items-center gap-2">
                    {remaining > 0 ? (
                        <>
                            {prefix} <span className="text-rose-600 font-bold">{formatCurrency(remaining, currency || 'EUR')}</span> {suffix}
                        </>
                    ) : (
                        <span className="text-green-600 flex items-center gap-1 font-bold">
                            <Truck size={16} /> {t('freeShippingUnlocked')}
                        </span>
                    )}
                    <span className="ml-auto text-xs text-gray-400">{progress.toFixed(0)}%</span>
                </div>
                <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden">
                    <div
                        className={`h-full transition-all duration-500 ease-out rounded-full ${remaining <= 0 ? 'bg-green-500' : 'bg-linear-to-r from-rose-400 to-red-500'}`}
                        style={{ width: `${progress}%` }}
                    />
                </div>
            </div>
            <Separator />
        </>
    );
};
